module.exports = __webpack_public_path__ + "static/Artboard_3-6f29d434fa2e9c2294fe52bf60140743.svg";